import { UploadButton } from './UploadButton';
export default UploadButton;